class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCount = 0;
    this.closeTimeout = null;
  }

  connectedCallback() {
    const summary = this.querySelector('summary');
    const megaContent = this.querySelector('.mega-menu__content');

    // Helper: increment hover count, cancel any pending close, and open if needed
    const hoverIn = () => {
      this.hoverCount++;
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', true);
      }
    };

    // Helper: decrement hover count, schedule close if nothing is hovered
    const hoverOut = () => {
      this.hoverCount = Math.max(0, this.hoverCount - 1);
      if (this.hoverCount === 0) {
        if (this.closeTimeout) clearTimeout(this.closeTimeout);
        this.closeTimeout = setTimeout(() => {
          if (this.hoverCount === 0 && !this.contains(document.activeElement)) {
            this.close();
          }
        }, 300);
      }
    };

    // Track the header-menu element itself (covers the summary/nav button area)
    this.addEventListener('mouseenter', hoverIn);
    this.addEventListener('mouseleave', hoverOut);

    // Track the absolutely-positioned dropdown content separately
    // (it renders outside the header-menu element bounds)
    if (megaContent) {
      megaContent.addEventListener('mouseenter', hoverIn);
      megaContent.addEventListener('mouseleave', hoverOut);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && this.hoverCount === 0) this.close();
    }, 100);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
